import { Type } from '@sinclair/typebox';
/**
 * A union schema over an `as const` list of strings, keeping the list as the
 * single source of truth.
 *
 * This exists because the obvious spelling is quietly broken:
 *
 * ```ts
 * Type.Union(CODES.map((code) => Type.Literal(code))) // infers as never
 * ```
 *
 * `.map` returns an array rather than a tuple, and `Static` walks a union's
 * members as a tuple - so the static type collapses to `never` while the
 * runtime schema stays perfectly correct. Nothing notices until a Fastify route
 * types a response schema, at which point the handler is asked for `never[]`.
 * Mapping the tuple type alongside the values keeps both halves right.
 */
export function literalUnion(values) {
    // The one cast: `.map` cannot produce a tuple type, and the tuple is the
    // whole point. The value is exactly what the annotation claims - the same
    // literals in the same order - so this narrows a true statement TypeScript
    // has no way to prove.
    return Type.Union(values.map((value) => Type.Literal(value)));
}
//# sourceMappingURL=union.js.map